import queryString from 'query-string';

export const onLoad = () => {
  const qs = queryString.parse(window.location.search);

  if (qs.utm_campaign) {
    localStorage.setItem('utm_campaign', qs.utm_campaign);
  }
};
